/* eslint-disable react/prop-types */
// Copyright (c) 2019 Deere & Company

import './warning-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import React from 'react';

export const WarningAlertBar = ({
    alertTitle, canDismiss, dismissHandler,
    timeoutLength, willAutoDismiss, children,
}) => (
    <div className="warning-alert-bar">
        <AlertBarBase
            alertTitle={alertTitle}
            canDismiss={canDismiss}
            dismissHandler={dismissHandler}
            iconClass="icon-alertWarning"
            timeoutLength={timeoutLength}
            willAutoDismiss={willAutoDismiss}
        >
            {children}
        </AlertBarBase>
    </div>
);

WarningAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: false,
};
